<template lang="html">
<div class="signup-container">
  <div class="signup-wrapper">
    <form class="form-wrapper" @submit.prevent="dispatchSignUp">
      <div class="form-error" v-if="signUpError">
        Oppsy Woopsy Something went fucky wucky up
      </div>

      <div class="signup-item">
        <label for="name"> Full Name </label>
        <input type="text" id="name" name="name" v-model="name" />
      </div>

      <div class="signup-item">
        <label for="email"> Email </label>
        <input type="email" id="email" name="email" v-model="email" />
      </div>

      <div class="signup-item">
        <label for="password"> Password </label>
        <input type="password" id="password" name="password" v-model="password" />
      </div>

      <div class="signup-item">
        <label for="confirm-password"> Confirm Password </label>
        <input type="password" id="confirm-password" name="confirm-password" v-model="passwordConfirmation" />
      </div>

      <button class="signup-button styled-button">
          Login
      </button>

    </form>

    <router-link class="link" :to="{ name: 'Login' }"> Already have an account? Login here.</router-link>

  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      name: '',
      email: '',
      password: '',
      passwordConfirmation: ''
    }
  },

  computed: {
    ...mapGetters([
      'signUpError'
    ])
  },

  methods: {
    ...mapActions([
      'handleSignUp'
    ]),

    dispatchSignUp() {
      const payload = this.constructSignUpPayload();
      this.handleSignUp(payload);
    },

    constructSignUpPayload() {
      return {
        'user': {
          'name': this.name,
          'email': this.email,
          'password': this.password,
          'password_confirmation': this.passwordConfirmation
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.signup-container {
   width: 355px;
   height: 620px;
   margin: 20px 10px;
   background-color: white;
   box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);

    @media only screen  and (min-width : 1224px) {
        width: 1140px;
        margin: 25px auto;
    }
}

.signup-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;
}

.form-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;
}

.form-error {
  display: flex;
  flex-direction: column;
  width: 50%;
  margin: auto;
  text-align: center;
  background-color: #ddd;
  color: red;
}

.signup-item {
  display: flex;
  flex-direction: column;
  margin: 25px auto 0;
  text-align: center;

  input {
    margin-top: 15px;
  }
}

.signup-button {
  margin: 25px auto;
  width: 150px;
}

.link {
  margin: 0 auto;
  font-size: 10px;
}

.styled-button {
  background: white;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px;
  letter-spacing: 1px;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: #8b8c8d;
  cursor: pointer;
  border: 1px solid #DDDEDF;
  text-transform: uppercase;
  transition: 0.1s all;
  font-size: 10px;
  outline: none;
  border-color: $primary-blue;
  color: $primary-blue;
  text-align: center;

  &:disabled {
    pointer-events: none;
    opacity: .2;
  }

  &:hover {
    color: white;
    border-color: $primary-blue;
    background: $primary-blue;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SignUp.vue